<div class="totals">
  <span class="totals-title">{{ 'cart.summaryTotals.summary' | translate }}</span>

  <div class="totals-item">
    <span class="totals-item-label">{{ 'cart.summaryTotals.subtotal' | translate }}</span>
    <span class="totals-item-value">{{ totalFactory }}</span>
  </div>

  <div class="totals-item">
    <span class="totals-item-label">{{ 'cart.summaryTotals.discounts' | translate }}</span>
    <span class="totals-item-value green">{{ discountValue }}</span>
  </div>

  <div class="totals-item">
    <span class="totals-item-label">{{ 'cart.summaryTotals.taxes' | translate }}</span>
    <span class="totals-item-value red">{{ taxValue }}</span>
  </div>

  <div class="totals-item">
    <span class="totals-item-label total">{{ 'cart.summaryTotals.total' | translate }}</span>
    <span class="totals-item-value total">{{ totalValue }}</span>
  </div>

  <!-- <div class="totals-item">
    <span class="totals-item-observation">{{ 'cart.summaryTotals.observation' | translate }}</span>
  </div> -->

  @if (insideButton && showButton) {
    <cx-button (click)="onButtonClick()" [disabled]="disableButton" [loading]="isLoadingButton || false" class="btn-success w-100">{{
      buttonText
    }}</cx-button>
  }
</div>
